module.exports = __webpack_public_path__ + "img/title.d1eacb5f.png";